import { observer } from "mobx-react-lite";
import { type JSX } from "react";

import {
  BaseWorkoutItemsList,
  type RenderGroup,
  type RenderNormal,
} from "./BaseWorkoutItemsList";
import { useWorkoutEditStore } from "./WorkoutEditContext";
import { type WorkoutItemLayout } from "./WorkoutEditStore";

interface MinimapWorkoutItemsListProps {
  renderGroup: (args: RenderGroup) => JSX.Element;
  renderNormal: (args: RenderNormal) => JSX.Element;
}

export const MinimapWorkoutItemsList = observer(
  function MinimapWorkoutItemsList(props: MinimapWorkoutItemsListProps) {
    const workoutEditStore = useWorkoutEditStore();

    function shouldSkipItem(item: WorkoutItemLayout): boolean {
      return workoutEditStore.isDraft(item.workoutItemId);
    }

    function getPreviousItemId(
      prevItem: WorkoutItemLayout | null,
    ): string | undefined {
      if (!prevItem) {
        return undefined;
      }

      if (workoutEditStore.isDraft(prevItem.workoutItemId)) {
        return undefined;
      }

      return prevItem.workoutItemId;
    }

    return (
      <BaseWorkoutItemsList
        items={workoutEditStore.layout.items}
        renderGroup={props.renderGroup}
        renderNormal={props.renderNormal}
        shouldSkipItem={shouldSkipItem}
        getPreviousItemId={getPreviousItemId}
      />
    );
  },
);
